import POSSelectField from '../../../POS/Fields/POSSelectField';

import POSCreditDaysSection from './POSCreditDaysSection';
import POSCreditMonthsSection from './POSCreditMonthsSection';
import POSCreditYearsSection from './POSCreditYearsSection';

interface Props {
  paymentCondition: any;

  terms: any[];

  onChangeTerm: (value: string | number) => void;
}

const POSCreditConfiguration: React.FC<Props> = ({
  paymentCondition,
  terms,
  onChangeTerm,
}) => {
  // =====================================================
  // 🔹 Term Code
  // =====================================================
  const termCode = paymentCondition?.termCode;

  // =====================================================
  // 🎨 Render
  // =====================================================
  return (
    <div
      className="
        rounded-lg
        border
        border-stroke

        bg-white

        p-4

        shadow-default

        dark:border-strokedark
        dark:bg-boxdark
      "
    >
      {/* ===================================================== */}
      {/* 🔹 Header */}
      {/* ===================================================== */}
      <div className="mb-4">
        <h4
          className="
            text-sm
            font-semibold
            text-black

            dark:text-white
          "
        >
          Configuración de Crédito
        </h4>

        <p
          className="
            mt-1
            text-xs
            text-body
          "
        >
          Define el plazo y vencimiento del crédito.
        </p>
      </div>

      {/* ===================================================== */}
      {/* 🔹 Term Selector */}
      {/* ===================================================== */}
      <POSSelectField
        label="Unidad del plazo"
        name="paymentCondition.term"
        value={paymentCondition?.termId || ''}
        options={terms.map((item) => ({
          value: item.id,
          label: item.name,
        }))}
        placeholder="Seleccionar plazo"
        iconKey="calendar"
        onChange={(e) => onChangeTerm(e.target.value)}
      />

      {/* ===================================================== */}
      {/* 🔹 Dynamic Section */}
      {/* ===================================================== */}
      <div className="mt-4">
        {termCode === '01' && <POSCreditDaysSection />}

        {termCode === '02' && <POSCreditMonthsSection />}

        {termCode === '03' && <POSCreditYearsSection />}
      </div>
    </div>
  );
};

export default POSCreditConfiguration;
